// extracted by mini-css-extract-plugin
export default {"coverLink":"rK-z","contentBox":"sK-z","zapposPromoContainer":"tK-z","zapposPromoGroupContainer":"uK-z","promos":"vK-z","bottom":"wK-z","top":"xK-z","right":"yK-z","left":"zK-z"};